import { useState, useContext } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { FaFileArchive } from "react-icons/fa";
import ReclamoContext from "../../../context/reclamo/reclamoContext";

const VideoComponent = ({ videoContinuarFunction }) => {
  const reclamoContext = useContext(ReclamoContext);
  const { data_usuario } = reclamoContext;

  const handleFuria = () => {
    window.open(
      `${"http://reclamos.superdesalud.gob.cl/home"}?run_atu=${data_usuario.run
      }&dv_atu=${data_usuario.dv}&nombres_atu=${data_usuario.nombre
      }&apellido_p_atu=${data_usuario.apellido_p}&apellido_m_atu=${data_usuario.apellido_m
      }`,
      "_self"
    );
  };

  const [CheckTerms, setCheckTerms] = useState(false);

  return (
    <Row className="form-ss" id="data-video">
      {/* <div className="div-icon-ss">
        <FaFileArchive className="icon-ss" />
      </div>
      <p className="col-12 my-0 text-center font-primary-ss mb-3">
        ¿Me solicitarán documentos?
      </p>

      <p className="text-justify font-weight-bold-500 my-0">
        Para subir el documento al sistema tendrás que seguir las instrucciones
        del siguiente vídeo.
      </p>

      <div className="col-12 my-3 px-0">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/y6RVRYz61wc"
          frameBorder="0"
          title="Video SuperIntendencia de Salud "
          allowFullScreen
        ></iframe>
      </div> */}
      {/* <p className="text-justify font-weight-bold-500 mb-5 mt-5">
        Te recordamos que en junio de 2021 entró en vigencia la Ley N°21.350 que introdujo cambios en la 
        forma en que se efectúa el reajuste del precio base del plan de salud. Para el periodo 2022-2023 fijó 
        como máximo el alza  en  7,6%.
      </p> */}
      <p className="text-justify font-weight-bold-500 mt-5">
        La normativa vigente dispone que el Superintendente de Salud establecerá un porcentaje máximo de alza 
        que las Isapres podrán aplicar a los precios base de los planes de salud. 
        <b> Dicho incremento se entenderá justificado para todos los efectos legales, el cual para este año 2025 es de hasta un 3,7%.</b>
      </p>

      <p className="text-justify font-weight-bold-500 mt-4 mb-5">
        En este formulario sólo podrás reclamar por el alza de precio en el plan de salud para el año 2025. Si el reclamo es por una materia distinta, 
        deberás seleccionar aquella que corresponda en el paso anterior (Paso 1). &nbsp;
        {/* <span
          onClick={() => handleFuria()}
          className="font-primary-ss pointer"
        >
          (Paso 1).
        </span> */}
      </p>
      <Form.Group controlId="formBasicCheckbox" className="mt-3 mx-auto">
        <Form.Check
          type="checkbox"
          label="Acepto términos y condiciones."
          value={CheckTerms}
          onChange={() => setCheckTerms(!CheckTerms)}
        />
      </Form.Group>

      <Col className="col-12 mb-5">
        <Button
          type="submit"
          className="btn-primary-ss mb-5 mx-auto  d-block"
          disabled={!CheckTerms}
          onClick={videoContinuarFunction}
        >
          Continuar{" "}
        </Button>
      </Col>
    </Row>
  );
};

export default VideoComponent;
